import styled from 'styled-components';

export const StyledBasicInput = styled.div`
  .MuiInputBase-root {
    width: 100% !important;
  }

  .MuiInputBase-input {
    width: 100% !important;
    border: 1px solid #dadada;
    border-radius: 0 !important;
    padding-left: 8px;
  }
`;
